import { FC } from 'react';

interface VerticalBoxOption {
  label: string;
  value: string;
}

interface VerticalBoxToggleProps {
  options: VerticalBoxOption[];
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

const VerticalBoxToggle: FC<VerticalBoxToggleProps> = ({
  options,
  selectedValue,
  setSelectedValue
}) => (
  <div className="flex flex-col">
    {options.map((option, index) => (
      <div
        key={option.value}
        role="presentation"
        className={`text-medium cursor-pointer border border-grey30 px-[14px] py-2  ${
          selectedValue === option.value
            ? 'bg-primary5 text-primary'
            : 'text-grey'
        }
        ${index === 0 && 'rounded-t'}
        ${index === options.length - 1 && 'rounded-b'}`}
        onClick={() => setSelectedValue(option.value)}
      >
        {option.label}
      </div>
    ))}
  </div>
);

export default VerticalBoxToggle;
